import React from 'react';

import Label from './Label';

export default function AchCheckStatus({ labels }) {
  return (
    <div className="flex gap-5">
      {labels.map((label) => {
        return (
          <Label
            key={label.title}
            title={label.title}
            value={label.value()}
            isVisible={label.isVisible()}
          />
        );
      })}
    </div>
  );
}
